// Loaded first (volto.config.js). @eeacms/volto-tabs-block depends on
// @eeacms/volto-block-style, which by default wraps EVERY block's view/edit in a
// style wrapper reading data.styles, the same key Volto Light Theme uses for
// block backgrounds/widths. An empty whitelist means it wraps nothing; the tabs
// block still uses block-style's helpers internally.
const applyConfig = (config) => {
  config.settings.pluggableStylesBlocksWhitelist = [];
  return config;
};
export default applyConfig;
